import React from 'react'
import { t, Trans } from '@lingui/macro'
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { FormSubmission } from '@/core/models/form.model'
import { useRespondToEthicsSubmission } from '../model/useRespondToEthicsSubmission'

type RespondToEthicsSubmissionDialogProps = {
  open: boolean
  onClose: () => void
  submission: FormSubmission
}

export function RespondToEthicsSubmissionDialog({ open, onClose, submission }: RespondToEthicsSubmissionDialogProps) {
  const { ethicsResponse, hasSubmitError, isLoading, canSubmit, setEthicsResponse, handleSubmit } = useRespondToEthicsSubmission({
    submission,
    onCompleted: onClose,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Trans>Respond to Ethical Question</Trans>
      </DialogTitle>
      <DialogContent>
        {hasSubmitError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            <Trans>An error occurred</Trans>
          </Alert>
        )}
        <TextField
          label={t`Response`}
          multiline
          rows={6}
          fullWidth
          sx={{ mt: 2 }}
          value={ethicsResponse}
          onChange={(event) => setEthicsResponse(event.target.value)}
          placeholder={t`Write the committee's response to this ethical question...`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!canSubmit}>
          {isLoading ? <CircularProgress size={20} /> : <Trans>Submit Response</Trans>}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
